

                if (!window.beaePageJS) {
                    window.beaePageJS = [];
                }
                let jsHandle_d0unyxq5ab = () => {
                    
                        if (document.querySelector('.beae-wwkslscb:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                                $el: document.querySelector('.beae-wwkslscb:not([data-beae-bind])'),
                                
                                id: 'beae-wwkslscb',
                                isLive: true
                            });
                            document.querySelector('.beae-wwkslscb:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                        if (document.querySelector('.beae-8gbypglc:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                                $el: document.querySelector('.beae-8gbypglc:not([data-beae-bind])'),
                                
                                id: 'beae-8gbypglc',
                                isLive: true
                            });
                            document.querySelector('.beae-8gbypglc:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                        if (document.querySelector('.beae-l6rnstc4:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                                $el: document.querySelector('.beae-l6rnstc4:not([data-beae-bind])'),
                                
                                id: 'beae-l6rnstc4',
                                isLive: true
                            });
                            document.querySelector('.beae-l6rnstc4:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                }
                if (window.beaejQuery) {
                    jsHandle_d0unyxq5ab()
                } else {
                    window.beaePageJS.push(jsHandle_d0unyxq5ab)
                }
            